import React from "react";
import {connect} from "react-redux";
import * as workActions from '../../actions/work.js';
import { Popup } from '@sekmet/react-magnific-popup';

class Work extends React.Component {

  componentDidMount() {
    this.props.dispatch(workActions.loadWork())
  }

  render() {
    const {work, error} = this.props.work;
    const loading = this.props.loading;

    if(loading.loading) { return <section id="portfolio" ref={this.props.innerRef} />; }

    const PopupConfig = {
      type:'inline',
      fixedContentPos: false,
      removalDelay: 200,
      showCloseBtn: false,
      mainClass: 'mfp-fade'
    };

    return(
        <section id="portfolio" ref={this.props.innerRef}>
          <div className="row">
            <h2>Here's what I've been up to</h2>
            <div className="twelve columns collapsed">
              <div id="portfolio-wrapper" className="bgrid-thirds s-bgrid-thirds cf">

                {work.map((work_item) =>
                <React.Fragment key={work_item.id}>
                  <div className="columns anchor-item">
                    <div className="item-wrap">
                      <Popup href={`#work-modal-${work_item.id}`} className="popup-anchor" config={PopupConfig} alt="title">
                        <h3>{work_item.name}</h3>
                        <img alt="" src={work_item.image.medium} />
                        <div className="overlay">
                          <div className="anchor-item-meta">
                            <h5>{work_item.name}</h5>
                            <p>{work_item.category_name}</p>
                          </div>
                        </div>
                        <div className="link-icon"><i className="icon-plus" /></div>
                      </Popup>
                    </div>
                  </div>
                  <div id={`work-modal-${work_item.id}`} className="popup-modal mfp-hide">
                    <img className="scale-with-grid" src={work_item.image.medium} alt="" />
                    <div className="description-box">
                      <h4>{work_item.name}</h4>
                      <p dangerouslySetInnerHTML={{__html: work_item.desc}}></p>
                      <span className="categories"><i className="fa fa-tag" />{work_item.tags}</span>
                    </div>
                    <div className="link-box">
                      <a href={work_item.client_url} target="_blank">Visit</a>
                      <a className="popup-modal-dismiss">Close</a>
                    </div>
                  </div>
                  </React.Fragment>
                  )}
                </div>
            </div>
          </div>
        </section>
    )
  }
}

const mapStateToProps = state => ({
  ...state,
  work: state.work
});

export default connect(mapStateToProps, null, null, {withRef: true})(Work);



// WEBPACK FOOTER //
// ./src/components/Work/Work.js